export default {
  // 获取体重管理问卷链接
  questionnairesDiabetesUrl(customer_id) {
    return this.http('Bee', 'get', `/go_api/v2/questionnaires_diabetes/${customer_id}/url`);
  },
  // 提交糖尿病问卷
  questionnairesDiabetes(data) {
    return this.http('Bee', 'put', '/go_api/v2/questionnaires_diabetes', data);
  },
  // 获取体重管理问卷链接
  questionnairesWeightMngUrl(customer_id) {
    return this.http('Bee', 'get', `/go_api/v2/questionnaires_weight_mng/${customer_id}/url`);
  },
  // 提交体重管理问卷
  questionnairesWeightMng(data) {
    return this.http('Bee', 'put', '/go_api/v2/questionnaires_weight_mng', data);
  },
  // 根据微信返回code获取一些信息
  questionnairesAuthCode(data) {
    return this.http('Bee', 'post', '/go_api/v2/questionnaires/auth_code', data);
  },
  // 用户获取问卷信息
  questionnairesOptions(data) {
    return this.http('Bee', 'post', '/go_api/v2/questionnaires/options', data);
  },
  // 判断用户是否填写问卷
  checkQuestionnaires(data) {
    return this.http('Bee', 'post', '/go_api/v2/questionnaires/check', data);
  },
  // 顾问获取用户填写问卷信息
  questionnairesOptionsByCustomerId(data) {
    return this.http('Bee', 'post', '/go_api/v2/questionnaires/options_by_customer_id', data);
  }
};
